import type { CityConfig } from "@/pages/city-template/types";

export const saratogaSpringsConfig: CityConfig = {
  city: "Saratoga Springs",
  state: "New York",
  stateAbbr: "NY",
  slug: "saratoga-springs",
  route: "/cities/saratoga-springs",
  title: "Emergency & Expedited Passport Saratoga Springs NY | Same Day Passport Saratoga",
  metaDescription:
    "Emergency passport Saratoga Springs NY — same day, 24-hour, and 3-5 day expedited passport processing for Saratoga County. Fast Passport Center serves Saratoga Springs, Ballston Spa, Malta, and all Capital Region communities.",
  h1: "Emergency & Expedited Passport Services in Saratoga Springs, NY",
  heroSubtitle:
    "Saratoga Springs' fast passport solution — from the Spa City to the Adirondacks. Whether you're flying out of Albany International or heading to JFK, Fast Passport Center delivers emergency passports in as little as 24 hours and expedited processing in 3-5 days.",
  heroImageUrl:
    "https://readdy.ai/api/search-image?query=Aerial%20view%20of%20Saratoga%20Springs%20New%20York%20with%20historic%20Broadway%20downtown%20district%2C%20beautiful%20tree-lined%20streets%2C%20Victorian%20architecture%2C%20Saratoga%20Race%20Course%20in%20the%20distance%2C%20Adirondack%20Mountains%20backdrop%2C%20warm%20golden%20afternoon%20light%2C%20modern%20travel%20photography%20with%20clean%20composition%2C%20no%20text%20overlay%2C%20upstate%20New%20York%20scenic%20small%20city&width=1600&height=700&seq=ny-saratoga-hero-001&orientation=landscape",
  heroImageAlt: "Saratoga Springs New York historic Broadway downtown with Adirondack Mountains backdrop",
  geoPosition: "43.0831; -73.7846",
  geoPlacename: "Saratoga Springs, New York, United States",
  lastModified: "2026-05-31",
  regionalAgency: {
    name: "New York Passport Agency",
    address: "376 Hudson Street, New York, NY 10014",
    distance: "~185 miles (Southeast in Manhattan)",
  },
  nearbyCitiesZips: [
    { name: "Saratoga Springs", zips: "12866, 12871" },
    { name: "Ballston Spa", zips: "12020" },
    { name: "Malta", zips: "12020" },
    { name: "Wilton", zips: "12831, 12866" },
    { name: "Clifton Park", zips: "12065" },
    { name: "Glens Falls", zips: "12801, 12804" },
    { name: "Queensbury", zips: "12804" },
    { name: "South Glens Falls", zips: "12803" },
    { name: "Mechanicville", zips: "12118" },
    { name: "Corinth", zips: "12822" },
    { name: "Lake George", zips: "12845" },
    { name: "Albany", zips: "12201-12212, 12214, 12220, 12222-12226, 12228, 12230, 12231, 12232, 12233, 12234, 12235, 12236, 12237, 12238, 12239, 12240, 12241, 12242, 12243, 12244, 12245, 12246, 12247, 12248, 12249, 12250, 12252, 12255, 12256, 12257, 12260, 12261, 12262, 12288" },
    { name: "Troy", zips: "12180, 12181, 12182, 12183" },
    { name: "Schenectady", zips: "12301-12309, 12325, 12345" },
    { name: "Utica", zips: "13501, 13502, 13503, 13504, 13505, 13599" },
    { name: "Syracuse", zips: "13201-13210, 13211, 13212, 13214, 13215, 13217, 13218, 13219, 13220, 13224, 13225, 13235, 13244, 13250, 13251, 13252, 13261, 13290" },
    { name: "Buffalo", zips: "14201-14204, 14206-14210, 14211-14214, 14215, 14216, 14217, 14218, 14219, 14220, 14221, 14222, 14223, 14224, 14225, 14226, 14227, 14228, 14231, 14233, 14240, 14241, 14260, 14261, 14263, 14264, 14265, 14267, 14269, 14270, 14272, 14273, 14276, 14280" },
    { name: "New York City", zips: "10001-10282, 11201-11251" },
  ],
  benefits: [
    {
      icon: "ri-time-line",
      title: "As Fast as 24 Hours",
      desc: "Emergency passport processing for Saratoga Springs travelers with urgent departures — same day service available for documented emergencies.",
    },
    {
      icon: "ri-shield-check-line",
      title: "Registered Courier",
      desc: "U.S. Department of State registered passport courier with direct access to the New York Passport Agency.",
    },
    {
      icon: "ri-customer-service-2-line",
      title: "Real Human Support",
      desc: "Dedicated agents guide you through every step — no chatbots, no automated runaround. Available for Saratoga Springs residents 7 days a week.",
    },
    {
      icon: "ri-map-pin-line",
      title: "Capital Region & Adirondacks",
      desc: "Saratoga Springs, Ballston Spa, Malta, and the entire Saratoga County — we serve the Capital Region and Adirondack gateway communities.",
    },
  ],
  testimonials: [
    {
      name: "Margaret S.",
      location: "Ballston Spa, NY",
      rating: 5,
      text: "Had a cruise departure in 5 days and my passport was expired. Fast Passport Center got it renewed in 3 days. Perfect for Saratoga Springs area residents.",
      service: "Passport Renewal",
    },
    {
      name: "Richard K.",
      location: "Malta, NY",
      rating: 5,
      text: "First-time passport for our family's Caribbean vacation. The agent was patient and thorough. Processed in 5 days with no issues.",
      service: "New Passport",
    },
    {
      name: "Barbara T.",
      location: "Clifton Park, NY",
      rating: 5,
      text: "Lost my passport before a business trip to Europe. Fast Passport Center handled the replacement and had it to me in 4 days. Excellent service.",
      service: "Lost Passport Replacement",
    },
  ],
  facilities: [
    {
      id: "saratoga-1",
      name: "Saratoga Springs Post Office",
      type: "Post Office / Passport Acceptance Facility",
      address: "475 Broadway",
      city: "Saratoga Springs",
      state: "NY",
      zip: "12866",
      phone: "518-584-4260",
      hours: "Mon-Fri 8:00 AM - 5:00 PM, Sat 9:00 AM - 1:00 PM",
      distance: "Downtown Saratoga Springs",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Major Saratoga Springs passport acceptance facility. First-time applicants and those not eligible for mail-in renewal must apply in person.",
      icon: "ri-building-2-line",
    },
    {
      id: "saratoga-2",
      name: "Ballston Spa Post Office",
      type: "Post Office / Passport Acceptance Facility",
      address: "100 Washington Street",
      city: "Ballston Spa",
      state: "NY",
      zip: "12020",
      phone: "518-885-4482",
      hours: "Mon-Fri 9:00 AM - 5:00 PM, Sat 9:00 AM - 12:00 PM",
      distance: "Ballston Spa (~5 miles south)",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Passport acceptance services available by appointment. Convenient for Ballston Spa and south Saratoga County residents.",
      icon: "ri-building-2-line",
    },
    {
      id: "saratoga-3",
      name: "Malta Post Office",
      type: "Post Office / Passport Acceptance Facility",
      address: "2450 Route 9",
      city: "Malta",
      state: "NY",
      zip: "12020",
      phone: "518-899-1476",
      hours: "Mon-Fri 9:00 AM - 5:00 PM, Sat 9:00 AM - 12:00 PM",
      distance: "Malta (~6 miles south)",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Passport acceptance services available. Serving Malta, Round Lake, and south Saratoga County communities.",
      icon: "ri-building-2-line",
    },
  ],
  faqs: [
    {
      q: "How fast can I get an emergency passport in Saratoga Springs?",
      a: "Fast Passport Center offers same-day emergency passport processing in as little as 24 hours for Saratoga Springs residents with documented life-or-death emergencies. For urgent travel within 2 weeks, our 3-5 day expedited service is the most popular option. Standard processing through the post office takes 8-11 weeks.",
    },
    {
      q: "Where is the closest passport acceptance facility in Saratoga Springs?",
      a: "The Saratoga Springs Post Office at 475 Broadway is the major Saratoga Springs passport acceptance facility. The Ballston Spa Post Office at 100 Washington Street and Malta Post Office at 2450 Route 9 are also convenient options. First-time applicants and those not eligible for mail-in renewal must apply in person.",
    },
    {
      q: "Can I get same-day passport photos in Saratoga Springs?",
      a: "Yes — passport photos are widely available at CVS Pharmacy, Walgreens, UPS Store, and FedEx Office locations throughout Saratoga Springs, Ballston Spa, and Malta. We also offer photo review as part of our service to ensure your 2x2 photos meet all State Department requirements.",
    },
    {
      q: "How much does an expedited passport cost in Saratoga Springs?",
      a: "Government fees are set by the State Department and vary based on passport type (book vs card, large book option). Fast Passport Center's service fees depend on processing speed: 10-day Smart Saver, 3-5 day Expedited, or 24-hour Emergency. Call 877-253-0084 for a personalized quote based on your Saratoga Springs passport needs.",
    },
    {
      q: "Do I need to visit the New York Passport Agency in person?",
      a: "No — if you use Fast Passport Center, you do not need to visit the New York Passport Agency in Manhattan. As a registered courier, we handle the agency submission for you. The only reason to visit the agency directly is for a documented life-or-death emergency, and appointments are extremely difficult to obtain.",
    },
    {
      q: "What is the fastest way to renew a passport in Saratoga Springs?",
      a: "The fastest way to renew a passport in Saratoga Springs is through Fast Passport Center's 3-5 day expedited service. If your most recent passport was issued when you were 16 or older, within the last 15 years, and is undamaged, you may qualify for renewal without an acceptance clerk visit. For even faster renewal, our 24-hour emergency service is available.",
    },
    {
      q: "Can I get a child passport expedited in Saratoga Springs?",
      a: "Yes — Fast Passport Center expedites child passports for minors under 16 in Saratoga Springs and all Saratoga County communities. Both parents must appear with the child or provide notarized consent (Form DS-3053). We review all parental consent documentation before submission to avoid delays.",
    },
    {
      q: "Does Fast Passport Center have an office in Saratoga Springs?",
      a: "Fast Passport Center operates as a remote courier service — we do not have a physical office in Saratoga Springs. We serve the Spa City and all of Saratoga County through our secure overnight shipping and agency submission process. Our headquarters are in Washington, DC.",
    },
  ],
  photoLocations: [
    { name: "CVS Pharmacy — Saratoga Springs", address: "various CVS locations across Saratoga Springs, Ballston Spa, and Malta", hours: "Mon-Sun, hours vary by location" },
    { name: "Walgreens — Saratoga Springs", address: "various Walgreens locations throughout Saratoga Springs and Saratoga County", hours: "Mon-Sun, hours vary by location" },
    { name: "UPS Store — Saratoga Springs", address: "various UPS Store locations in Saratoga Springs and Ballston Spa", hours: "Mon-Fri 9:00 AM - 7:00 PM, Sat 10:00 AM - 4:00 PM" },
    { name: "FedEx Office — Saratoga Springs", address: "various FedEx Office locations across Saratoga Springs", hours: "Mon-Fri 8:00 AM - 9:00 PM, Sat-Sun 10:00 AM - 6:00 PM" },
    { name: "Walmart Photo Center — Saratoga Springs", address: "various Walmart locations in Saratoga Springs and Ballston Spa", hours: "Mon-Sun 8:00 AM - 10:00 PM" },
  ],
  dmvLocations: [
    {
      name: "NYS DMV — Saratoga Springs",
      address: "6 Care Lane, Saratoga Springs, NY 12866",
      hours: "Mon-Fri 8:30 AM - 4:00 PM",
      note: "Saratoga Springs DMV office for license renewals and REAL ID applications. Accepts walk-ins but appointments are strongly recommended.",
      featured: true,
    },
    {
      name: "NYS DMV — Ballston Spa",
      address: "40 Front Street, Ballston Spa, NY 12020",
      hours: "Mon-Fri 8:30 AM - 4:00 PM",
      note: "Ballston Spa DMV office serving south Saratoga County and Ballston Spa residents.",
      featured: false,
    },
    {
      name: "NYS DMV — Clifton Park",
      address: "3 Clifton Country Road, Clifton Park, NY 12065",
      hours: "Mon-Fri 8:30 AM - 4:00 PM",
      note: "Clifton Park DMV office serving south Saratoga County, Clifton Park, and Malta communities.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "ALB",
      name: "Albany International Airport",
      distance: "~35 miles from Saratoga Springs",
      address: "737 Albany Shaker Road, Albany, NY 12211",
      note: "Capital Region's primary airport with flights to major U.S. cities and some international destinations. About 35 minutes from Saratoga Springs.",
      flightUrl: "https://www.albanyairport.com/",
      flightLabel: "Albany Airport",
      featured: true,
    },
    {
      code: "SCH",
      name: "Schenectady County Airport",
      distance: "~25 miles from Saratoga Springs",
      address: "70 Airport Road, Scotia, NY 12302",
      note: "General aviation airport in Schenectady. Primarily for private flights and charter services.",
      flightUrl: "https://www.schenectadyairport.com/",
      flightLabel: "Schenectady Airport",
      featured: false,
    },
    {
      code: "JFK",
      name: "John F. Kennedy International Airport",
      distance: "~185 miles from Saratoga Springs",
      address: "JFK Access Road, Queens, NY 11430",
      note: "Major international hub with flights to virtually every destination worldwide. Direct access via Amtrak and bus connections.",
      flightUrl: "https://www.jfkairport.com/",
      flightLabel: "JFK Airport",
      featured: false,
    },
  ],
  services: [
    {
      icon: "ri-passport-line",
      title: "Emergency Passport",
      description: "For Saratoga Springs travelers with urgent departures within 24 hours to 2 weeks. Direct New York Passport Agency submission with dedicated courier handling.",
      bullets: ["Processing as fast as 24 hours", "Dedicated agent assigned to your case", "Daily status updates"],
      badge: "Fastest",
      link: "https://fastpassportcenter.com/checkout/?passport=emergency-passport",
    },
    {
      icon: "ri-refresh-line",
      title: "Passport Renewal",
      description: "Fast renewal for Saratoga Springs residents with a valid passport issued within the last 15 years at age 16 or older.",
      bullets: ["3-5 day or 10-day options available", "No acceptance clerk visit required", "Secure overnight document return"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-user-add-line",
      title: "New Passport",
      description: "First-time passport application assistance for Saratoga Springs residents with step-by-step guidance through the acceptance clerk process.",
      bullets: ["Complete application review before submission", "Acceptance clerk appointment guidance", "3-5 day or 10-day processing options"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alarm-warning-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement service for Saratoga Springs residents who have lost their passport or had it stolen.",
      bullets: ["DS-64 form guidance included", "Replacement in 3-5 days or 10 days", "Acceptance clerk visit required"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 in Saratoga Springs, with parental consent guidance and acceptance clerk support.",
      bullets: ["Parental consent documentation review", "Both parents present or notarized consent", "3-5 day or 10-day processing available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal name change for Saratoga Springs residents.",
      bullets: ["Marriage certificate or court order review", "Name change in 3-5 days or 10 days", "No clerk visit for most renewals"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for Saratoga Springs travelers with immediate departure needs from Albany International or JFK." },
    { name: "Passport Renewal", description: "Fast passport renewal for Saratoga Springs residents with a recent valid passport." },
    { name: "New Passport", description: "First-time passport application assistance for Saratoga Springs residents." },
    { name: "Lost or Stolen Passport", description: "Passport replacement for Saratoga Springs residents who have lost their passport." },
    { name: "Child Passport", description: "Passport services for minors under 16 in Saratoga Springs and Saratoga County." },
    { name: "Name Change", description: "Passport name change service after marriage, divorce, or legal name change in Saratoga Springs." },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Photos must be 2\"x2\" with a plain white or off-white background. Many Saratoga Springs travelers get rejected at the acceptance clerk because their photos don't meet strict State Department specs.",
    },
    {
      icon: "ri-file-list-3-line",
      title: "Missing or Incorrect Forms",
      description: "Using the wrong form (DS-11 vs DS-82) or missing required fields can cause weeks of delays. We review every form before submission.",
    },
    {
      icon: "ri-calendar-line",
      title: "Waiting Too Long to Start",
      description: "Standard processing takes 8-11 weeks. Many Saratoga Springs travelers wait until the last minute, leaving no buffer for problems.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Incorrect Payment Amount",
      description: "Government fees change frequently. Using an outdated check or wrong amount will cause your application to be returned.",
    },
    {
      icon: "ri-shield-line",
      title: "Damaged or Expired ID",
      description: "Your driver's license or state ID must be valid and unexpired. Many applicants don't realize their ID is about to expire until it's too late.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For child passports, both parents must appear or provide notarized consent. Missing documentation is the #1 reason child applications are delayed.",
    },
  ],
  steps: [
    {
      number: "01",
      icon: "ri-file-list-3-line",
      title: "Complete Your Application",
      description: "Fill out your passport application online or over the phone with our Saratoga Springs team. We review everything for accuracy.",
    },
    {
      number: "02",
      icon: "ri-upload-cloud-line",
      title: "Send Us Your Documents",
      description: "Ship your documents via overnight courier to our secure processing center. We confirm receipt and begin review immediately.",
    },
    {
      number: "03",
      icon: "ri-search-line",
      title: "We Review Everything",
      description: "Our agents verify your forms, photos, and supporting documents meet all State Department requirements — no surprises.",
    },
    {
      number: "04",
      icon: "ri-shield-check-line",
      title: "Courier Submission",
      description: "As a registered U.S. Department of State courier, we submit your application directly to the New York Passport Agency.",
    },
    {
      number: "05",
      icon: "ri-passport-line",
      title: "Receive Your Passport",
      description: "Your passport is delivered securely to your Saratoga Springs address. We provide tracking and daily status updates throughout.",
    },
  ],
  processingOptions: [
    {
      speed: "8-11",
      unit: "weeks",
      label: "Standard Processing",
      tag: "Post Office",
      tagColor: "bg-gray-200 text-gray-600",
      features: [
        "Mail-in application",
        "No expedited handling",
        "No dedicated agent",
        "No phone or email contact for your case",
        "Updates only by physical mail letter",
      ],
      highlight: false,
      muted: true,
    },
    {
      speed: "10",
      unit: "business days",
      label: "Smart Saver",
      tag: "Fast Passport Center",
      tagColor: "bg-green-100 text-green-700",
      features: [
        "Secure overnight shipping included",
        "Document review before submission",
        "Dedicated agent assigned",
        "Daily status updates",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "3-5",
      unit: "business days",
      label: "Expedited Processing",
      tag: "Recommended",
      tagColor: "bg-[#1A365D] text-white",
      features: [
        "Secure overnight shipping included",
        "Document review before submission",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "24",
      unit: "hours",
      label: "Emergency Processing",
      tag: "Life or Death",
      tagColor: "bg-red-100 text-red-600",
      features: [
        "For documented life-or-death emergencies only",
        "Requires proof of emergency travel",
        "Strictly for documented life-or-death emergencies",
      ],
      highlight: false,
      emergency: true,
    },
  ],
  comparisonRows: [
    { feature: "Appointment Required", agency: "Must book weeks in advance", fpc: "No appointment needed — we handle agency access" },
    { feature: "Processing Speed", agency: "1-2 business days (if you get an appointment)", fpc: "As fast as 3-5 days or 24 hours for emergencies" },
    { feature: "Document Review", agency: "No pre-check — one mistake means restart", fpc: "Complete review before submission — we catch errors" },
    { feature: "Travel Proof", agency: "Requires printed itinerary with confirmed travel within 2 weeks", fpc: "Flexible documentation requirements" },
    { feature: "Updates", agency: "No phone or email support — only mail updates", fpc: "Daily status updates via phone and email" },
    { feature: "Guarantee", agency: "No guarantee of appointment or same-day processing", fpc: "Reserved agency slots with predictable processing" },
  ],
  stickyNavLinks: [
    { label: "Processing Options", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  internalLinks: [
    { name: "New York City", route: "/cities/new-york-city" },
    { name: "Brooklyn", route: "/cities/brooklyn" },
    { name: "Queens", route: "/cities/queens" },
    { name: "Buffalo", route: "/cities/buffalo" },
    { name: "Albany", route: "/cities/albany-ny" },
    { name: "Syracuse", route: "/cities/syracuse" },
    { name: "Rochester", route: "/cities/rochester" },
    { name: "Yonkers", route: "/cities/yonkers" },
    { name: "The Bronx", route: "/cities/the-bronx" },
    { name: "Staten Island", route: "/cities/staten-island" },
    { name: "Long Island", route: "/cities/long-island" },
    { name: "Binghamton", route: "/cities/binghamton" },
    { name: "White Plains", route: "/cities/white-plains" },
    { name: "Poughkeepsie", route: "/cities/poughkeepsie" },
    { name: "Newburgh", route: "/cities/newburgh" },
    { name: "New Rochelle", route: "/cities/new-rochelle" },
    { name: "Utica", route: "/cities/utica" },
    { name: "Rome", route: "/cities/rome-ny" },
    { name: "Schenectady", route: "/cities/schenectady" },
    { name: "Troy", route: "/cities/troy" },
    { name: "Lake George", route: "/cities/lake-george" },
    { name: "Ballston Spa", route: "/cities/ballston-spa" },
    { name: "Malone", route: "/cities/malone" },
    { name: "Tupper Lake", route: "/cities/tupper-lake" },
    { name: "Amsterdam", route: "/cities/amsterdam-ny" },
    { name: "Gloversville", route: "/cities/gloversville" },
    { name: "New York State", route: "/states/new-york" },
  ],
  fpcOfficeNote:
    "Fast Passport Center serves Saratoga Springs and all of Saratoga County as a remote courier service. We do not have a physical office in Saratoga Springs, but our secure overnight shipping network ensures your documents reach our processing center quickly and safely.",
  fpcOfficeDistance: "Remote courier service — Saratoga Springs area",
  serviceAreaIntro:
    "Fast Passport Center provides expedited passport services to Saratoga Springs and all of Saratoga County. From the Spa City to the Adirondacks, from Ballston Spa to Malta — we serve upstate New York with the same fast, reliable processing.",
  nearbyCitiesIntro:
    "We proudly serve Saratoga Springs and all surrounding communities across Saratoga County and the Capital Region. Whether you're in Ballston Spa, Malta, or Glens Falls, our expedited passport services are available to you.",
  howItWorksIntro:
    "Our Saratoga Springs customers follow a simple, proven process to get their passports fast. No agency visits, no waiting in lines, no guessing.",
  mistakesIntro:
    "These are the most common mistakes Saratoga Springs travelers make when applying for an expedited passport. Avoiding them saves weeks of delays.",
  testimonialsIntro:
    "Saratoga Springs travelers trust Fast Passport Center for their urgent passport needs. Here's what they say about our service.",
  faqIntro:
    "Common questions about emergency and expedited passport services in Saratoga Springs. If you don't see your question here, call us at 877-253-0084.",
  statePageRoute: "/states/new-york",
  statePageName: "New York Passport Services",
};

export default saratogaSpringsConfig;